import colors from "../../theme/colors";
import MySettingsModal from "../Users/mySettingsModal";
import NavBar from "../Navigation/navbar";
import styled from "styled-components";
import { createTheme } from "@mui/material/styles";
import { ThemeProvider, Alert, AlertTitle } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { remove as removeNotification } from "../../redux-store/notificationsSlice";
import ModalComponent from "../Modal";
import OkForm from "../Forms/okForm";
import { updateShowSupportModal } from "../../redux-store/uxSlice";
import AcceptTermsModal from "../TermsConditionsPrivacyPolicy/acceptTermsModal";

const theme = createTheme({
  typography: {
    fontFamily: ["Roboto", '"Helvetica Neue"', "Arial"].join(","),
  },
  palette: {
    primary: {
      light: `${colors.blueLight}`,
      main: `${colors.blue}`,
      dark: `${colors.blueDark}`,
      contrastText: `${colors.white}`,
    },
    secondary: {
      light: `${colors.orange}`,
      main: `${colors.white}`,
      dark: `${colors.black}`,
      contrastText: `${colors.black}`,
    },
    black: {
      light: `${colors.black}`,
      main: `${colors.black}`,
      dark: `${colors.black}`,
      contrastText: `${colors.white}`,
    },
  },
});

const NotificationsContainer = styled.div`
  z-index: 1101;
  position: fixed;
  top: 20px;
  right: 20px;
  margin-left: 20px;
  width: 100%;
  max-width: 300px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 5px;
  @media print {
    display: none !important;
  }
`;

const LayoutContainer = ({ children }) => {
  const notifications = useSelector((state) => state.notifications);
  const { showSupportModal } = useSelector((state) => state.ux);

  const dispatch = useDispatch();
  return (
    <ThemeProvider theme={theme}>
      <NavBar />
      <NotificationsContainer>
        {notifications.map((note) => {
          return (
            <Alert
              key={note.id}
              onClose={() => {
                dispatch(removeNotification(note.id));
              }}
              severity={note.severity}
              sx={{
                "& .MuiAlert-icon": {
                  color: "white",
                },
                width: "100%",
                color: "white",
                backgroundColor:
                  note.severity === "success"
                    ? colors.greenSuccess
                    : colors.redError,
              }}
            >
              <AlertTitle>{note.title}</AlertTitle>
              {note.message}
            </Alert>
          );
        })}
      </NotificationsContainer>
      <MySettingsModal />
      <AcceptTermsModal />
      <ModalComponent
        headerText="Contact Customer Support"
        open={showSupportModal}
      >
        <OkForm
          handleOk={() => {
            dispatch(updateShowSupportModal(false));
          }}
        >
          Please email{" "}
          <a href="mailto:support@boreasmonitoring.com">
            support@boreasmonitoring.com
          </a>{" "}
          for all support inquiries and questions. If you are experiencing
          issues with the Boreas Portal, please describe your issue in detail
          and provide screenshots if applicable. We will be quick to assist you.
        </OkForm>
      </ModalComponent>
    </ThemeProvider>
  );
};

export default LayoutContainer;
